export default __webpack_public_path__ + "static/media/logo.220ea051.png";